import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
import configs from '@/configs';

const endpoint = 'vehicle';

// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        ID: 0,
        VehicleCode: '',
        LicensePlate: '',
        Status: 0,
        NumberOfPack: 0,
        NumberOfProduct: 0,
        TotalWeight: 0.0,
        TotalVolume: 0.0,
        Orders: [],
        OrderIDs: [],
        AvailableOrders: [],
        BigPackages: [],
        BigPackageIDs: [],
        AvailableBigPackages: [],
        SmallPackages: []
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        return new Promise((resolve) => {
            commit("setLoading", { loading: true });
            request_list(endpoint, data => {
                commit('setVehicleList', data);
                commit("setLoading", { loading: false });
                resolve(data);
            }, Vue.http, param, this.state.authentication.token);
        });
    },
    getDetail({ commit }, {id, param}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(endpoint, data => {
                    commit('setDetail', data);
                    commit("setLoading", { loading: false });
                    resolve(data.data);
                }, Vue.http, id, this.state.authentication.token, param);
            }, 100);
        });
    },
    getAvailableOrders(_, vehicleId = 0) {
        return new Promise((resolve, reject) => {
            Vue.http.get(`${configs.API}/admin/api/vehicle/available-orders/?vehicle_id=${vehicleId || 0}`, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(res => {
                resolve(res.data.data || []);
            }).catch(reject);
        });
    },
    getAvailableBigPackages(_, vehicleId = 0) {
        return new Promise((resolve, reject) => {
            Vue.http.get(`${configs.API}/admin/api/vehicle/available-bigpackages/?vehicle_id=${vehicleId || 0}`, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(res => {
                resolve(res.data.data || []);
            }).catch(reject);
        });
    },
    getOrderPackages(_, orderIds = []) {
        return new Promise((resolve, reject) => {
            Vue.http.post(`${configs.API}/admin/api/vehicle/order-packages/`, {
                OrderIDs: orderIds
            }, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(res => {
                resolve(res.data.data || []);
            }).catch(reject);
        });
    },
    getBigPackagePackages(_, bigPackageIds = []) {
        return new Promise((resolve, reject) => {
            Vue.http.post(`${configs.API}/admin/api/vehicle/bigpackage-packages/`, {
                BigPackageIDs: bigPackageIds
            }, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(res => {
                resolve(res.data.data || []);
            }).catch(reject);
        });
    },
    setDetail({ dispatch }, {data, id, param}) {
        return new Promise((resolve, reject) => {
            if(id > 0) {
                data.ModifiedBy = this.state.authentication.user.username;
                update_detail(endpoint, res => {
                    if (res.data.status === 'fail') {
                        sendErrorNotice(res.data.error || 'Không thể cập nhật xe hàng.');
                        reject(res);
                    }
                    else {
                        sendSuccessNotice('Cập nhật xe hàng thành công.');
                        refreshResource();
                        resolve(res);
                    }
                }, Vue.http, data, id, this.state.authentication.token);
            }
            else {
                data.CreatedBy = this.state.authentication.user.username;
                delete data.ID;
                create_detail(endpoint, res => {
                    if (res.data.status === 'fail') {
                        if(res.data.error === 'No orders selected' || res.data.error === 'No transport sources selected') {
                            sendErrorNotice('Danh sách đơn hàng hoặc bao hàng đã chọn không hợp lệ hoặc đã được xếp xe. Vui lòng chọn lại.');
                        }
                        else {
                            sendErrorNotice(res.data.error || 'Không thể thêm mới xe hàng.');
                        }
                        reject(res);
                    }
                    else {
                        sendSuccessNotice('Thêm mới xe hàng thành công.');
                        refreshResource();
                        resolve(res);
                    }
                }, Vue.http, data, this.state.authentication.token);
            }
        });
    },
    confirmStoreVn({ commit }, vehicleId) {
        return new Promise((resolve, reject) => {
            Vue.http.post(`${configs.API}/admin/api/vehicle/${vehicleId}/confirm-store-vn/`, {}, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(res => {
                sendSuccessNotice('Nhập kho cả xe thành công.');
                resolve(res.data);
            }).catch(err => {
                sendErrorNotice('Không thể nhập kho cả xe.');
                reject(err);
            });
        });
    },
    removeDetail({ commit }, id) {
        if(id == 0) {
            return;
        }
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa xe hàng.');
            }
            else {
                sendSuccessNotice('Đã xóa xe hàng thành công.');
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    }
};

// mutations
const mutations = {
    setVehicleList(state, data) {
        state.all = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
